/**
 * Vocabulario de tipo de cambio compartido por el Estado Financiero y
 * Tesorería. Espeja `CASAS` del backend (`server/src/lib/dolarApi.ts`) —
 * si agregás una casa allá, agregala acá.
 *
 * Las series salen de argentinadatos.com y son ARGENTINAS: en México no hay
 * serie, así que las pantallas esconden estos controles fuera de AR en vez
 * de ofrecer una conversión que no existe.
 */
export const CASAS_DOLAR = ['oficial', 'blue', 'mayorista', 'bolsa', 'contadoconliqui'] as const;
export type CasaDolar = (typeof CASAS_DOLAR)[number];

export const CASAS_DOLAR_LABEL: Record<CasaDolar, string> = {
  oficial: 'Oficial',
  blue: 'Blue',
  mayorista: 'Mayorista',
  bolsa: 'MEP',
  contadoconliqui: 'CCL',
};

/** Unidad en la que se muestra un tablero: moneda local o dólares. */
export type VistaMoneda = 'local' | 'usd';
